/* eslint-disable */
import React, { Component } from "react";
import { ScriptCache } from "../lib/ScriptCache";
import { GoogleApi } from "../lib/GoogleApi";

const defaultCreateCache = options => {
  const opts = options || {};

  const client = opts.client;
  const libraries = opts.libraries || ["places"];
  const version = opts.version || "3.30";
  const language = opts.language || "en";
  const region = opts.region || "US";

  return ScriptCache({
    google: GoogleApi({
      client,
      language,
      libraries,
      version,
      region
    })
  });
};

const wrapper = options => WrappedComponent => {
  const createCache = options.createCache || defaultCreateCache;

  class Wrapper extends Component {
    constructor(props, context) {
      super(props, context);

      // Get provided API keys.
      if (props.app.googleClientId) options.client = props.app.googleClientId;

      this.scriptCache = createCache(options);
      this.scriptCache.google.onLoad(this.onLoad.bind(this));

      this.state = {
        loaded: false,
        google: null
      };
    }

    onLoad() {
      this.GAPI = window.google;
      this.setState({ loaded: true, google: this.GAPI });
    }

    render() {
      const props = Object.assign({}, this.props, {
        loaded: this.state.loaded,
        google: window.google
      });

      return <div>{props.google && <WrappedComponent {...props} />}</div>;
    }
  }

  return Wrapper;
};

export default wrapper;
